<template>
	<div class="container">
		<div class="row" >
			<form id="AcceptParcelForm" @submit="onSubmit" class="accept-parcel">
				<div class="page-header">
					<strong>ثبت مرسوله</strong>
				</div>
				<div class="alert alert-light mt-3">
					<strong class="d-block mb-2">مرحله {{ level }} از {{ totalLevel}}</strong>
					<div class="progress">
						<div class="progress-bar bg-success" role="progressbar" :style="{'width': (Math.round(( level / totalLevel ) * 100)).toString() + '%' }"></div>
					</div>
				</div>
				<div v-if="level == 1" class="accept-parcel-cart mt-3">
					<strong class="mb-4 mt-3 d-block">اطلاعات فرستنده</strong>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderCustomerRolId"><span>نوع کاربری فرستنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<select class="form-select" id="senderCustomerRolId" v-model="senderCustomerRolId"
									@change="onChangeDropDown" data-name="senderCustomerRolText">
								<option v-for="(item, index) in customerRols" :key="index" :value="item.value">
									{{ item.text }}
								</option>
							</select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderFullName"><span>نام حقوقی/حقیقی فرستنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" class="form-control" id="senderFullName" v-model="senderFullName"
								   data-label="نام حقوقی/حقیقی فرستنده" data-validations='["required"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderNationalCode"><span>کد/شناسه ملی فرستنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text"
								   inputmode="numeric" class="form-control" id="senderNationalCode" v-model="senderNationalCode"
								   :data-role-Id="senderCustomerRolId" data-label="کد/شناسه ملی فرستنده" data-validations='["required","number","nationalcode"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderMobile"><span>موبایل فرستنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="senderMobile" v-model="senderMobile"
								   data-label="موبایل فرستنده" data-validations='["required","mobile"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderTel">تلفن ثابت فرستنده</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="senderTel" v-model="senderTel"
								   data-label="تلفن ثابت فرستنده" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderPostalCode"><span>کد پستی فرستنده</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="senderPostalCode" v-model="senderPostalCode"
								   data-label="کد پستی فرستنده" data-validations='["postalcode","number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderCityId"><span>شهر مبدا</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<v-select
									v-model="senderCityId"
									label="cityName"
									:options="cities"
									:clearable="false"
									:reduce="(o) => o.cityId"
									@option:selecting="(o) => {senderCityText = o.cityName}"
									>
										<template v-slot:option="option">
											{{ option.countryName }} > {{ option.provinceName }} > {{ option.cityName }}
										</template>
									</v-select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="senderAddress"><span>آدرس فرستنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" class="form-control" id="senderAddress" v-model="senderAddress"
								   data-label="آدرس فرستنده" data-validations='["required"]' />
						</div>
					</div>
				</div>
				<div v-if="level == 2" class="accept-parcel-cart mt-3">
					<strong class="mb-4 mt-3 d-block">اطلاعات گیرنده</strong>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverCustomerRolId"><span>نوع کاربری گیرنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<select class="form-select" id="receiverCustomerRolId" v-model="receiverCustomerRolId"
									@change="onChangeDropDown" data-name="receiverCustomerRolText">
								<option v-for="(item, index) in customerRols" :key="index" :value="item.value">
									{{ item.text }}
								</option>
							</select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverFullName"><span>نام حقوقی/حقیقی گیرنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" class="form-control" id="receiverFullName" v-model="receiverFullName"
								   data-label="نام حقوقی/حقیقی گیرنده" data-validations='["required"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverNationalCode">کد/شناسه ملی گیرنده</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="receiverNationalCode" v-model="receiverNationalCode"
								   :data-role-Id="receiverCustomerRolId" data-label="کد/شناسه ملی" data-validations='["number","nationalcode"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverMobile"><span>موبایل گیرنده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="receiverMobile" v-model="receiverMobile"
								   data-label="موبایل گیرنده" data-validations='["required","mobile"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverTel">تلفن ثابت گیرنده</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="receiverTel" v-model="receiverTel"
								   data-label="تلفن ثابت گیرنده" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverPostalCode"><span>کد پستی گیرنده</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" inputmode="numeric" class="form-control" id="receiverPostalCode" v-model="receiverPostalCode"
								   data-label="کد پستی گیرنده" data-validations='["postalcode","number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverCityId"><span>شهر مقصد</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<v-select
									v-model="receiverCityId"
									label="cityName"
									:options="cities"
									:clearable="false"
									:reduce="(o) => o.cityId"
									@option:selecting="(o) => {receiverCityText = o.cityName}"
									>
										<template v-slot:option="option">
											{{ option.countryName }} > {{ option.provinceName }} > {{ option.cityName }}
										</template>
									</v-select>

						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="receiverAddress"><span>آدرس گرینده</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" class="form-control" id="receiverAddress" v-model="receiverAddress"
								   data-label="آدرس گرینده" data-validations='["required"]' />
						</div>
					</div>
				</div>
				<div v-if="level == 3" class="accept-parcel-cart mt-3">
					<strong class="mb-4 mt-3 d-block">درج اطلاعات مرسوله</strong>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="serviceId"><span>نوع سرویس</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<select class="form-select" v-model="serviceId" data-label="نوع سرویس" data-validations='["required"]'
									@change="onChangeDropDown" data-name="serviceText">
								<option v-for="(service, index) in getActiveServices()" :key="index" :value="service.serviceId">
									{{ service.serviceName }}
								</option>
							</select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="paymentMethodId"><span>روش پرداخت هزینه</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<select class="form-select" v-model="paymentMethodId"
									@change="onChangeDropDown" data-name="paymentMethodText">
								<option v-for="(item, index) in paymentMethods" :key="index" :value="item.value">
									{{ item.text }}
								</option>
							</select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="valueAddedServices"><span>ارسال پیامک اطلاع رسانی</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<select class="form-select" v-model="valueAddedServices"
									@change="onChangeDropDown" data-name="valueAddedServicesText">
								<option v-for="(item, index) in valueAddedServicesList" :key="index" :value="item.value">
									{{ item.text }}
								</option>
							</select>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="weight"><span>وزن مرسوله</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="weight" v-model="weight"
								   data-label="وزن مرسوله" data-validations='["required","number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="length">طول مرسوله</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="length" v-model="length"
								   data-label="طول مرسوله" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="width">عرض مرسوله</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="width" v-model="width"
								   data-label="عرض مرسوله" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="height">ارتفاع مرسوله</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="height" v-model="height"
								   data-label="ارتفاع مرسوله" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="priceGoods">ارزش خوداظهاری</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="priceGoods" v-model="priceGoods"
								   data-label="ارزش خوداظهاری" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="priceProduct">مبلغ کالا</label>
						</div>
						<div class="col-12 col-md-9">
							<input type="number" inputmode="numeric" class="form-control" id="priceProduct" v-model="priceProduct"
								   data-label="مبلغ کالا" data-validations='["number"]' />
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12 col-md-3">
							<label for="packageContent"><span>محتوای بسته</span><span class="text-danger">*</span></label>
						</div>
						<div class="col-12 col-md-9">
							<input type="text" class="form-control" id="packageContent" v-model="packageContent"
								   data-label="محتوای بسته" data-validations='["required"]' />
						</div>
					</div>
				</div>
				<div v-if="level == 4" class="accept-parcel-cart mt-3">
					<div class="text-center">
						<strong class="alert alert-light d-block">
							<span>در صورتی که بارکد اختصاصی دریافت کرده اید میتوانید با استفاده دوربین گوشی یا تبلت خود آن را اسکن نمایید</span><br />
							<span>و یا شماره بارکد را به صورت دستی در فیلد بارکد وارد نمایید.</span><br />
							<img style="max-width:150px;" :src="require('../../../assets/img/dashbord/barcode-scanner.png')" />
						</strong>
					</div>

					<div class="row mt-4 mb-2">
						<div class="col-12 col-lg-8 ms-auto me-auto">
							<button type="button" @click="showScanner = true" class="btn btn-outline-dark w-100">جهت اسکن بارکد کلیک کنید</button>

							<div class="text-center mt-2 mb-2" style="font-size:30px;">
								<strong>یا</strong>
							</div>
							<input type="text"
								   class="form-control"
								   inputmode="numeric"
								   placeholder="بارکد را در این قسمت وارد نمایید"
								   data-label="بارکد"
								   id="refNumber"
								   v-model="refNumber"
								   data-validations='["number"]' />
						</div>
					</div>
				</div>
				<div v-if="level == 5" class="accept-parcel-cart mt-3">
					<div class="row mt-4 mb-2">
						<strong class="alert alert-light d-block border border-bottom">
							<span>لطفا نحوه ارسال مرسوله به دفتر قبول را انتخاب نمایید</span>
						</strong>
						<div class="form-check">
							<input class="form-check-input" type="radio" :value="true" @change="firstOfficeId=null" v-model="isRequestCourier" name="IsRequestCourier" id="IsRequestCourier_True">
							<label class="form-check-label" for="IsRequestCourier_True">
								درخواست پیک دارم.
							</label>
						</div>
						<div class="form-check">
							<input class="form-check-input" type="radio" :value="false" @change="firstOfficeId=null" v-model="isRequestCourier" name="IsRequestCourier" id="IsRequestCourier_False">
							<label class="form-check-label" for="IsRequestCourier_False">
								خودم مرسوله را تحویل دفتر قبول میدهم.
							</label>
						</div>
					</div>

					<div class="row mt-4 mb-2">
						<strong class="alert alert-light d-block border border-bottom">
							<span>نزدیک ترین دفتر به خود را انتخاب نمایید</span>
						</strong>
						<div v-if="offices.length > 0" class="form-check" v-for="(office,index) in offices" :key="index">
							<input class="form-check-input" type="radio" :value="office.officeId" v-model="firstOfficeId" name="firstOfficeId_radio" :id="`foId_${office.officeId}`">
							<label class="form-check-label" :for="`foId_${office.officeId}`">
								{{ office.officeName }} - {{office.address}} - {{office.tel}}
							</label>
						</div>
						<div v-else>
							<strong class="text-danger">در حال حاضر هیچ دفتری در نزدیکی شما پیک ندارد.</strong>
						</div>
					</div>
				</div>
				<div v-if="level == 6" class="accept-parcel-cart mt-3">
					<div class="alert alert-light border mb-3">
						<strong>اطلاعات مرسوله شما به صورت زیر وارد شده است. <br/> در صورتی که از صحت اطلاعات وارد شده اطمینان دارید جهت محاسبه قیمت روی دکمه ادامه کلیک نمایید.</strong>
					</div>
					<table class="table bg-white">
						<tbody>
							<tr>
								<th class="bg-light" colspan="2">مشخصات فرستنده</th>
							</tr>
							<tr>
								<th>نوع کاربری فرستنده</th>
								<td>{{ senderCustomerRolText }}</td>
							</tr>
							<tr>
								<th>نام حقوقی/حقیقی فرستنده</th>
								<td>{{ senderFullName }}</td>
							</tr>
							<tr>
								<th>کد/شناسه ملی فرستنده</th>
								<td>{{ senderNationalCode }}</td>
							</tr>
							<tr>
								<th>موبایل فرستنده</th>
								<td>{{ senderMobile }}</td>
							</tr>
							<tr>
								<th>تلفن ثابت فرستنده</th>
								<td>{{ senderTel }}</td>
							</tr>
							<tr>
								<th>کد پستی فرستنده</th>
								<td>{{ senderPostalCode }}</td>
							</tr>
							<tr>
								<th>شهر مبدا</th>
								<td>{{ senderCityText }}</td>
							</tr>
							<tr>
								<th>آدرس فرستنده</th>
								<td>{{ senderAddress }}</td>
							</tr>
							<tr>
								<th class="bg-light" colspan="2">مشخصات گیرنده</th>
							</tr>
							<tr>
								<th>نوع کاربری گیرنده</th>
								<td>{{ receiverCustomerRolText }}</td>
							</tr>
							<tr>
								<th>نام حقوقی/حقیقی گیرنده</th>
								<td>{{ receiverFullName }}</td>
							</tr>
							<tr>
								<th>کد/شناسه ملی گیرنده</th>
								<td>{{ receiverNationalCode }}</td>
							</tr>
							<tr>
								<th>موبایل گیرنده</th>
								<td>{{ receiverMobile }}</td>
							</tr>
							<tr>
								<th>تلفن ثابت گیرنده</th>
								<td>{{ receiverTel }}</td>
							</tr>
							<tr>
								<th>کد پستی گیرنده</th>
								<td>{{ receiverPostalCode }}</td>
							</tr>
							<tr>
								<th>شهر مقصد</th>
								<td>{{ receiverCityText }}</td>
							</tr>
							<tr>
								<th>آدرس گیرنده</th>
								<td>{{ receiverAddress }}</td>
							</tr>
							<tr>
								<th class="bg-light" colspan="2">مشخصات مرسوله</th>
							</tr>
							<tr>
								<th>بارکد اختصاصی</th>
								<td>{{ refNumber }}</td>
							</tr>
							<tr>
								<th>نوع سرویس</th>
								<td>{{ serviceText }}</td>
							</tr>
							<tr>
								<th>روش پرداخت هزینه</th>
								<td>{{ paymentMethodText }}</td>
							</tr>
							<tr>
								<th>ارسال پیامک اطلاع رسانی</th>
								<td>{{ valueAddedServicesText }}</td>
							</tr>
							<tr>
								<th>وزن مرسوله</th>
								<td>{{ weight }}</td>
							</tr>
							<tr>
								<th>طول مرسوله</th>
								<td>{{ length }}</td>
							</tr>
							<tr>
								<th>عرض مرسوله</th>
								<td>{{ width }}</td>
							</tr>
							<tr>
								<th>ارتفاع مرسوله</th>
								<td>{{ height }}</td>
							</tr>
							<tr>
								<th>ارزش خود اظهاری</th>
								<td>{{ priceGoods }}</td>
							</tr>
							<tr>
								<th>مبلغ کالا</th>
								<td>{{ priceProduct }}</td>
							</tr>
							<tr>
								<th>محتوای بسته</th>
								<td>{{ packageContent }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="level == 7" class="accept-parcel-cart mt-3">
					<div class="alert alert-light border mb-2">
						<strong>صورت حساب نهایی مرسوله شما به شرح زیر است، به جهت ثبت نهایی مرسوله روی دکمه ادامه کلیک نمایید.</strong>
					</div>
					<table class="table bg-white">
						<tbody>
							<tr>
								<th width="200px">کرایه پستی</th>
								<td>{{ new Intl.NumberFormat().format(price.fare) }} ریال</td>
							</tr>
							<tr>
								<th>هزینه بیمه</th>
								<td>{{ new Intl.NumberFormat().format(price.priceInsurance) }} ریال</td>
							</tr>
							<tr>
								<th>هزینه خارج از اندازه</th>
								<td>{{ new Intl.NumberFormat().format(price.priceOversizedServices) }} ریال</td>
							</tr>
							<tr>
								<th>هزینه خدمات</th>
								<td>{{ new Intl.NumberFormat().format(price.priceValueAddedServices) }} ریال</td>
							</tr>
							<tr>
								<th>مالیات بر ارزش افزوده</th>
								<td>{{ new Intl.NumberFormat().format(price.totalTax) }} ریال</td>
							</tr>
							<tr>
								<th>مبلغ کل</th>
								<td>{{ new Intl.NumberFormat().format(price.totalPrice) }} ریال</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="level == 8" class="accept-parcel-cart mt-3">
					<div v-if="saveState == 1">
						<div class="alert alert-success">
							<strong>مرسوله با موفقیت ثبت شد.</strong>
						</div>
						<table class="table">
							<tbody>
								<tr>
									<th>شماره بارکد</th>
									<td><strong>{{barcode}}</strong></td>
								</tr>
								<tr>
									<th>دفتر قبول</th>
									<td>{{firstOffice.officeName}}</td>
								</tr>
								<tr>
									<th>تلفن دفتر قبول</th>
									<td>{{firstOffice.tel}}</td>
								</tr>
								<tr>
									<th>آدرس دفتر قبول</th>
									<td>{{firstOffice.address}}</td>
								</tr>
							</tbody>
						</table>
						<div class="alert alert-light">
							با کلیک بر روی هریک از دکمه های زیر میتوانید آخرین وضعیت مرسولات خود را مشاهده نمایید.
						</div>
					</div>
					<div v-if="saveState == -1">
						<div class="alert alert-danger">
							<strong>خطایی در ثبت مرسوله به وجود آمده است.</strong>
						</div>
						<table class="table table-borderless">
							<tbody>
								<tr>
									<th>
										محتوای خطا
									</th>
									<td>
										{{ saveErrorMessage }}
									</td>
								</tr>
								<tr>
									<th>
										محتوای خطا
									</th>
									<td>
										<span v-for="(error,index) in saveErrors" :key="index">
											{{error}}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="alert alert-warning mt-3" v-if="warnings.length">
					<ul>
						<li v-for="warning in warnings">
							{{ $t(warning.type,{label:warning.label}) }}
						</li>
					</ul>
				</div>
				<div class="alert alert-danger mt-3" v-if="errors.length">
					<ul>
						<li v-for="error in errors">
							{{ $t(error.type,{label:error.label}) }}
						</li>
					</ul>
				</div>
				<div class="action" v-if="level < totalLevel">
					<button class="btn btn-light m-2" v-if="level > 1" type="button" @click="level=level-1">
						<span>
							<i class="bi-arrow-right-circle me-3"></i>
							<strong class="d-inline-block pt-1">بازگشت</strong>
						</span>
					</button>
					<button class="btn btn-light" v-if="level < totalLevel" type="submit" v-bind:disabled="loading">
						<span v-if="!loading">
							<strong class="d-inline-block pt-1">ادامه</strong>
							<i class="bi-arrow-left-circle ms-3"></i>
						</span>
						<span v-if="loading" class="spinner-border spinner-border-sm"></span>
					</button>
				</div>
				<div class="action" v-else>
					<button class="btn btn-light m-2" v-if="saveState == -1" type="button" @click="level=level-1">
						<span>
							<i class="bi-arrow-right-circle me-3"></i>
							<strong class="d-inline-block pt-1">بازگشت</strong>
						</span>
					</button>
					<button class="btn btn-light m-2" v-if="saveState == 1" type="button" @click="$router.push('/club/tracking-parcels')">
						<span>
							<strong class="d-inline-block pt-1">رهگیری مرسوله</strong>
						</span>
					</button>
					<button class="btn btn-light m-2" v-if="saveState == 1" type="button" @click="$router.push('/club/parcels')">
						<span>
							<strong class="d-inline-block pt-1">مشاهده لیست کامل مرسولات</strong>
						</span>
					</button>
				</div>
			</form>
		</div>
	</div>

	<div v-if="showScanner" class="modal fade show" style="display:block;">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content show">
				<div class="modal-header">
					<h5 class="modal-title">اسکن بارکد</h5>
				</div>
				<div class="modal-body">
					<div class="alert alert-light">
						<strong>جهت اسکن بارکد دوربین گوشی خود را نزدیک به بارکد بگیرید.</strong>
					</div>
					<div dir="ltr" class="border" style="max-width:600px; margin:0 auto;">
						<StreamBarcodeReader @decode="onDecodeBarcode"></StreamBarcodeReader>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="showScanner = false" class="btn btn-danger me-4" data-bs-dismiss="modal">بستن</button>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import store from "@/common/store";
	import utility from '@/plugins/utility';
	import { StreamBarcodeReader } from "vue-barcode-reader";

	import vSelect from 'vue-select'
	import 'vue-select/dist/vue-select.css';

	export default {

		components: {
			StreamBarcodeReader,
			'v-select': vSelect
		},

		data()
		{
			return {

				saveState: 0,
				//saveState: 1,
				saveErrors: [],
				saveErrorMessage: '',
				level: 1,
				//level: 8,
				totalLevel: 8,
				showScanner: false,
				loading: false,
				errors: [],
				warnings: [],
				cities: [],
				services: [],
				customerRols: [
					{ text: 'حقیقی', value: '1' },
					{ text: 'حقوقی', value: '2' }
				],
				paymentMethods: [
					{ text: 'پیشکرایه', value: '1' },
					{ text: 'پسکرایه', value: '2' }
				],

				valueAddedServicesList: [
					{ text: 'بله ارسال شود', value: 'true' },
					{ text: 'خیر نیاز ندارم', value: 'false' }
				],

				firstOfficeId: null,
				senderCustomerId: null,
				senderCustomerRolText: 'حقیقی',
				senderCustomerRolId: '1',
				senderFullName: '',
				senderNationalCode: '',
				senderMobile: '',
				senderTel: '',
				senderPostalCode: '',
				senderCityText: '',
				senderCityId: '',
				senderAddress: '',

				onlineOffices: [],
				receiverCustomerRolText: 'حقیقی',
				receiverCustomerRolId: '1',
				receiverFullName: '',
				receiverNationalCode: '',
				receiverMobile: '',
				receiverTel: '',
				receiverPostalCode: '',
				receiverCityText: '',
				receiverCityId: '',
				receiverAddress: '',

				serviceText: '',
				serviceId: '',

				paymentMethodText: 'پیشکرایه',
				paymentMethodId: '1',

				valueAddedServicesText: 'بله ارسال شود',
				valueAddedServices: 'true',

				weight: '',
				width: '',
				height: '',
				length: '',
				refNumber: '',
				priceProduct: '',
				priceGoods: '',
				packageContent: '',
				isRequestCourier: false,
				barcode: '',
				allowNextTime: Date.now()
			};
		},


		beforeMount()
		{
			const customer = store.customer || {};
			this.senderCustomerId = customer.customerId;
			this.senderCustomerRolId = customer.customerRolId;
			this.senderCustomerRolText = customer.customerRolName;
			this.senderFullName = customer.fullName;
			this.senderNationalCode = customer.nationalCode;
			this.senderMobile = customer.mobile;
			this.senderTel = customer.tel;
			this.senderPostalCode = customer.postalCode;
			this.senderCityId = customer.cityId;
			this.senderCityText = customer.cityName;
			this.senderAddress = customer.address;
		},

		mounted()
		{
			this.getServices();
			this.getCities();
			this.getOnlineOffices()
		},

		computed:
		{
			resetLeftCharge()
			{
				try
				{
					this.request('/api/Club/GetCustomerInfo', null, (response) =>
					{
						if (response)
						{
							store.customer = response
						}

					}, 'get');
				} catch (e){}
			},


			offices()
			{
				var result = [];
				for (var i = 0; i < this.onlineOffices.length; i++)
				{
					var office = this.onlineOffices[i];
					if (this.isRequestCourier == true && office.isOnline == false)
					{
						continue;
					}

					result.push(office)
				}

				return result;
			},

			firstOffice()
			{
				return this.onlineOffices.find((x) => { return x.officeId == this.firstOfficeId }) || {};
			}
		},

		methods: {

			onChangeDropDown(e)
			{
				var text = e.target.options[e.target.options.selectedIndex].text;
				var dataName = e.target.getAttribute("data-name");

				this[dataName] = text
			},

			getCities()
			{
				this.request('/api/Club/GetCities', null, (response) =>
				{
					if (response)
					{
						this.cities = response.cities;
					}
				}, 'get');
			},

			getServices()
			{
				this.request('/api/Club/GetServices', null, (response) =>
				{
					if (response)
					{
						this.services = response.services;
					}
				}, 'get');
			},


			getActiveServices()
			{
				var result = [];

				var senderCity =
					this.cities.find((x) =>
					{
						return x.cityId == this.senderCityId
					});

				var receiverCity =
					this.cities.find((x) =>
					{
						return x.cityId == this.receiverCityId
					});

				if (senderCity && receiverCity)
				{
					for (var i = 0; i < this.services.length; i++)
					{
						var service = this.services[i];

						if ((receiverCity.metropolis && service.metropolis) || (!receiverCity.metropolis && !service.metropolis))
						{
							switch (service.serviceTypeId)
							{
								case 1:
									if (senderCity.cityId == receiverCity.cityId)
									{
										result.push(service)
									}
									break;

								case 2:
									if ((senderCity.cityId != receiverCity.cityId) && (senderCity.countryId == receiverCity.countryId))
									{
										result.push(service)
									}
									break;

								case 3:
									if (senderCity.countryId != receiverCity.countryId)
									{
										result.push(service)
									}
									break;
							}
						}
					}
				}

				return result;

			},

			getOnlineOffices()
			{
				this.request('/api/Club/GetOnlineOffices', {
					SenderCityID: this.senderCityId
				}, (response) =>
				{
					if (response)
					{
						this.onlineOffices = response.offices;
					}
				});
			},

			onSubmit(evt)
			{
				evt.preventDefault()
				var form = new utility.form('#AcceptParcelForm');
				this.warnings = form.errors();
				this.errors = [];

				if (this.warnings.length == 0)
				{
					if (this.level == 5)
					{
						if (this.firstOfficeId != null)
						{
							this.level = 6;
							setTimeout(() => { window.scrollTo(0, 0) }, 50);
						}
						else
						{
							this.errors.push({ type: 'validation.required', label: 'دفتر قبول' })
						}
					}
					else if (this.level == 6)
					{
						this.request('/api/Club/PriceInquery', {
							ServiceID: this.serviceId,
							SenderCityID: this.senderCityId,
							ReceiverCityID: this.receiverCityId,
							ValueAddedServices: this.valueAddedServices,
							Weight: this.weight,
							Width: this.width,
							Height: this.height,
							Length: this.length

						}, (response) =>
						{
							if (response.success)
							{
								this.price = response.price
								this.level = 7;
								setTimeout(() => { window.scrollTo(0, 0) }, 50);
							}
							else
							{
								this.errors.push({ type: 'errors.noAccess' })
							}
						})
					}
					else if (this.level == 7)
					{
						this.request('/api/Club/SaveParcel', {
							SenderCustomerRolID: this.senderCustomerRolId,
							SenderFullName: this.senderFullName,
							SenderNationalCode: this.senderNationalCode,
							SenderMobile: this.senderMobile,
							SenderTel: this.senderTel,
							SenderPostalCode: this.senderPostalCode,
							SenderCityID: this.senderCityId,
							SenderAddress: this.senderAddress,

							ReceiverCustomerRolID: this.receiverCustomerRolId,
							ReceiverFullName: this.receiverFullName,
							ReceiverNationalCode: this.receiverNationalCode,
							ReceiverMobile: this.receiverMobile,
							ReceiverTel: this.receiverTel,
							ReceiverPostalCode: this.receiverPostalCode,
							ReceiverCityID: this.receiverCityId,
							ReceiverAddress: this.receiverAddress,

							ServiceID: this.serviceId,
							SenderCustomerID: this.senderCustomerId,
							SenderCityID: this.senderCityId,
							ReceiverCityID: this.receiverCityId,
							FirstOfficeID: this.firstOfficeId,
							PaymentMethodID: this.paymentMethodId,
							ValueAddedServices: this.valueAddedServices,
							Weight: this.weight,
							Width: this.width,
							Height: this.height,
							Length: this.length,
							RefNumber: this.refNumber,
							PriceProduct: this.priceProduct,
							PriceGoods: this.priceGoods,
							PackageContent: this.packageContent,
							IsRequestCourier: this.isRequestCourier,
						}, (response) =>
						{
							if (response.success)
							{
								this.barcode = response.meta.barcode
								this.resetLeftCharge();
								this.saveState = 1;
							}
							else
							{
								this.saveState = -1;
								this.saveErrorMessage = response.meta.message;
								this.saveErrors = response.meta.errors;
							}

							this.level = 8;
							setTimeout(() => { window.scrollTo(0, 0) }, 50);

						})
					}
					else
					{
						if (Date.now() > this.allowNextTime)
						{
							this.level += 1;
							setTimeout(() => { window.scrollTo(0, 0) }, 50);
							this.allowNextTime = Date.now() + 1000
						}
					}

				}

			},

			onDecodeBarcode(result)
			{
				this.barcode = result
				this.showScanner = false
			},

			onErrorBarcode(result)
			{
				console.log(result)
			},

			request(url, data, succees, method)
			{
				this.loading = true;
				axios({
					method: method || 'post',
					url: url,
					data: data
				})
					.then(response =>
					{
						this.loading = false;
						succees(response.data)
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			},
		},
	};
</script>

<style>
	.accept-parcel {
		max-width: 900px;
		margin: 0 auto;
	}

		.accept-parcel .action {
			margin-top: 10px;
		}

			.accept-parcel .action button {
				background-color: #ffffff;
				min-width: 150px;
				height: 50px;
				border: 1px solid #ddd;
			}

		.accept-parcel button i {
			color: #FFC600;
			font-size: 20px;
			position: relative;
			top: 4px;
		}


		.accept-parcel .accept-parcel-cart {
			background-color: #fff;
			padding: 10px 20px;
			border-bottom: #ddd solid 2px;
		}

	.vs__dropdown-toggle {
		 padding: 6px 0px 9px
	}
</style>
